import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-shared-header',
  templateUrl: 'shared-header.component.html'
})

export class SharedHeaderComponent implements OnInit {

  constructor(private router: Router,
              private loginService: LoginService) { }

  ngOnInit() { }

  logout() {
    this.loginService.logout();
    this.router.navigate(['/login']);
  }
}
